module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "Modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [(_vm.email) ? _c('div', {
    staticClass: "modal__content modal__content--md",
    attrs: {
      "id": "ModalContent"
    }
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            " + _vm._s(_vm.email.name) + " "), _c('app-title-custom')], 1), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "intro-y box py-5"
  }, [_c('div', {
    staticClass: "wizard flex flex-col px-5"
  }, [_c('div', {
    staticClass: "bg-gray-200 p-2 rounded-md"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n              " + _vm._s(_vm.email.campaign_attribute.project_name) + " -\n              " + _vm._s(_vm.email.campaign_attribute.project_account_name) + " -\n              " + _vm._s(_vm.email.campaign_attribute.project_account_country_prefix) + " -\n              " + _vm._s(_vm.email.campaign_attribute.name) + "\n            ")]), _vm._v(" "), (_vm.email.hours) ? _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("HORAS:")]), _vm._v(" " + _vm._s(_vm.email.hours) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Creada el día:")]), _vm._v(" " + _vm._s(_vm.email.created_at) + "\n              "), _c('b', [_vm._v("por")]), _vm._v(" " + _vm._s(_vm.email.user_created_name) + "\n              "), (_vm.email.path) ? _c('a', {
    staticClass: "text-blue-500",
    attrs: {
      "href": _vm.email.path,
      "target": "_blank"
    }
  }, [_vm._v("Ver archivo aquí")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n              La tarea fue realizada por "), _c('b', [_vm._v(_vm._s(_vm.email.user_name))])]), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n              " + _vm._s(_vm.email.response_observations) + " "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.email.date))]), _vm._v(" "), (_vm.email.response_path) ? _c('a', {
    staticClass: "text-blue-500",
    attrs: {
      "href": _vm.email.response_path,
      "target": "_blank"
    }
  }, [_vm._v("\n                Ver archivo aquí\n              ")]) : _vm._e()])]), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.versions), function(version) {
    return (version.email_id == _vm.email.id) ? _c('div', {
      staticClass: "bg-gray-100 rounded-md mb-2 p-2"
    }, [_vm._v("\n            " + _vm._s(version.observations) + " "), _c('br'), _vm._v("\n            " + _vm._s(version.created_at) + "\n            "), (version.path) ? _c('a', {
      staticClass: "text-blue-500",
      attrs: {
        "href": version.path,
        "target": "_blank"
      }
    }, [_vm._v("Ver archivo aquí")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Respuesta")]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(version.response_observations) + " "), _c('br'), _vm._v("\n            " + _vm._s(version.updated_at) + "\n            "), (version.response_path) ? _c('a', {
      staticClass: "text-blue-500",
      attrs: {
        "href": version.response_path,
        "target": "_blank"
      }
    }, [_vm._v("Ver archivo aquí")]) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e()
  })], 2)])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Respuesta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Versiones")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-109992b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/email/ViewEmailModal.vue
// module id = 410
// module chunks = 1